import React from 'react';
import { ClipboardList, FileText, BarChart3, Home, File, CheckCircle, User, LogOut, Lock, Eye, EyeClosed, PieChart, Zap, Database, UserX } from 'lucide-react';
import { API_BASE_URL } from '../config';
import { useState } from 'react';

function PasswordChangeModal({ isOpen, onClose }) {
  const [showPassword, setShowPassword] = useState(false);
  if (!isOpen) return null;
  const handlePasswordChange = (e) => {
    e.preventDefault();
    const currentPassword = e.target[0].value;
    const newPassword = e.target[1].value;
    const confirmNewPassword = e.target[2].value;
    if (newPassword !== confirmNewPassword) {
      alert('New passwords do not match!');
      return;
    }
    fetch(`${API_BASE_URL}/api/auth/change-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ currentPassword, newPassword })
    }).then(response => {
      if (response.ok) {
        alert('Password changed successfully!');
      } else {
        alert('Failed to change password. Please check your current password.');
      }
    }).catch(error => {
      console.error('Error changing password:', error);
      alert('An error occurred. Please try again later.');
    });


    onClose();
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#f9fafb',
        padding: '24px',
        borderRadius: '8px',
        width: '400px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
      }}>
        <div  style={{display:'flex',flexDirection:'row', alignItems:'center', alignContent:'center',marginBottom:'16px'}}>
        <h2>Change Password</h2>
        </div>
        <form onSubmit={handlePasswordChange}>
          <div style={{ marginBottom: '12px' }}>
            <label>Current Password</label>
            <input type={showPassword ? "text" : "password"} style={{ width: '100%', padding: '8px', marginTop: '4px' }} />
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label>New Password</label>
            <input type={showPassword ? "text" : "password"} style={{ width: '100%', padding: '8px', marginTop: '4px' }} />
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label>Confirm New Password</label>
            <input type={showPassword ? "text" : "password"} style={{ width: '100%', padding: '8px', marginTop: '4px' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <div onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          {showPassword ? <EyeClosed /> : <Eye />}
        </div>
            <button type="button" className="button-outline" onClick={onClose}>Cancel</button>
            <button type="submit" className="button-primary">Change Password</button>
          </div>
        </form>
      </div>
    </div>
  );
}



export default function Navigation({ user, currentView, onNavigate, onLogout, pendingCount = 0 }) {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = React.useState(false);

  const openPasswordModal = () => {
    setIsPasswordModalOpen(true);
  };
  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
  };


  return (
    <nav style={{
      background: '#f4f5f7',
      borderBottom: '1px solid #dce0e6',
      padding: '0 32px',
      height: '64px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '20px', fontWeight: '700', color: '#0f172a' }}>
            Rapid Approve
          </span>
        </div>

        <div style={{ display: 'flex', gap: '8px' }}>
          {user.role === 'admin' && (
            <>
              <button
                onClick={() => onNavigate('admin-forms')}
                className={currentView === 'admin-forms' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <FileText size={16} style={{ marginRight: '4px' }} /> Forms
              </button>
              <button
                onClick={() => onNavigate('admin-requests')}
                className={currentView === 'admin-requests' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <BarChart3 size={16} style={{ marginRight: '4px' }} /> All Requests
              </button>
              <button
                onClick={() => onNavigate('admin-reports')}
                className={currentView === 'admin-reports' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <PieChart size={16} style={{ marginRight: '4px' }} /> Reports
              </button>
              <button
                onClick={() => onNavigate('admin-triggers')}
                className={currentView === 'admin-triggers' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <Zap size={16} style={{ marginRight: '4px' }} /> Triggers
              </button>
              <button
                onClick={() => onNavigate('admin-lookups')}
                className={currentView === 'admin-lookups' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <Database size={16} style={{ marginRight: '4px' }} /> Lookups
              </button>
              <button
                onClick={() => onNavigate('admin-replacements')}
                className={currentView === 'admin-replacements' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <UserX size={16} style={{ marginRight: '4px' }} /> Replacements
              </button>
            </>
          )}
          {user.role === 'employee' && (
            <>
              <button
                onClick={() => onNavigate('employee-dashboard')}
                className={currentView === 'employee-dashboard' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <Home size={16} style={{ marginRight: '4px' }} /> Dashboard
              </button>
              <button
                onClick={() => onNavigate('employee-requests')}
                className={currentView === 'employee-requests' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <File size={16} style={{ marginRight: '4px' }} /> My Requests
              </button>
              <button
                onClick={() => onNavigate('employee-approvals')}
                className={currentView === 'employee-approvals' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px', position: 'relative' }}
              >
                <CheckCircle size={16} style={{ marginRight: '4px' }} /> Approvals
                {pendingCount > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: '-4px',
                    right: '-4px',
                    background: '#dc2626',
                    color: 'white',
                    borderRadius: '10px',
                    padding: '2px 6px',
                    fontSize: '11px',
                    fontWeight: '600',
                    minWidth: '18px',
                    textAlign: 'center'
                  }}>
                    {pendingCount}
                  </span>
                )}
              </button>
              <button
                onClick={() => onNavigate('employee-reports')}
                className={currentView === 'employee-reports' ? 'button-primary' : 'button-outline'}
                style={{ padding: '8px 16px' }}
              >
                <PieChart size={16} style={{ marginRight: '4px' }} /> Reports
              </button>
            </>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>

        {/* <button
          onClick={onLogout}
          className="button-outline"
          style={{ padding: '8px 16px' }}
        >
          <LogOut size={16} style={{ marginRight: '4px' }} /> Logout
        </button> */}
        {/* <button
        className='button-outline'
        onClick={openPasswordModal}
        >
          <Lock size={16} style={{ marginRight: '4px' }} />
          Change Password
        </button> */}
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '8px 16px',
          background: '#f8fafc',
          borderRadius: '8px'
        }}>
          <User size={20} />
          <div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: '#0f172a' }}>
              {user.employeeName}
            </div>
            <div style={{ fontSize: '12px', color: '#64748b' }}>
              {user.role === 'admin' ? 'Administrator' : 'Employee'}
            </div>
          </div>
        </div>
      </div>
      <PasswordChangeModal isOpen={isPasswordModalOpen} onClose={closePasswordModal} />
    </nav>
  );
}
